import React from "react";
import { Field } from "./components/Field";
import { GoogleMapsAutocomplete } from "./components/GoogleMapsAutocomplete/GoogleMapsAutocomplete";
import Text from "../../../../shared/components/Text";
import { NonControlledField } from "./components/NonControlledField";

export const AutocompleteAddressHeadless = () => {};

AutocompleteAddressHeadless.Address = ({ apiKey, hidden, ...props }) => {
  return (
    <GoogleMapsAutocomplete
      name={"address.address"}
      label={<Text tId="ADDRESS" />}
      placeholder={"C/ de Balmes, 1, 08001 Barcelona, España"}
      apiKey={apiKey}
      hidden={hidden}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.StreetName = ({ as, formMethods, ...props }) => (
  <Field
    name="address.streetName"
    as={as}
    label={"STREET_NAME"}
    error={formMethods.errors?.address?.streetName}
    placeholder={"C/ de Muntaner"}
    {...props}
  />
);

AutocompleteAddressHeadless.StreetNumber = ({ as, formMethods, ...props }) => (
  <Field
    name="address.streetNumber"
    error={formMethods.errors?.address?.streetNumber}
    as={as}
    label={"STREET_NUMBER"}
    {...props}
  />
);

AutocompleteAddressHeadless.PostalCode = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="address.postalCode"
      error={formMethods.errors?.address?.postalCode}
      as={as}
      label={"POSTAL_CODE"}
      placeholder={"08015"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.Province = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="address.province"
      error={formMethods.errors?.address?.province}
      as={as}
      label={"PROVINCE"}
      placeholder={"Barcelona"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.City = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="address.city"
      error={formMethods.errors?.address?.city}
      as={as}
      label={"CITY"}
      placeholder={"Barcelona"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.FloorNumber = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="complementAddress.floorNumber"
      as={as}
      error={formMethods.errors?.complementAddress?.floorNumber}
      label={"ADDRESS_FLOOR"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.DoorNumber = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="complementAddress.doorNumber"
      as={as}
      error={formMethods.errors?.complementAddress?.doorNumber}
      label={"ADDRESS_DOOR"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.Building = ({ as, formMethods, ...props }) => {
  return (
    <Field
      name="complementAddress.building"
      as={as}
      label={"BUILDING_LABEL"}
      error={formMethods.errors?.complementAddress?.building}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.Country = ({ as, formMethods, ...props }) => {
  return (
    <NonControlledField
      name="address.country"
      as={as}
      label={"COUNTRY"}
      placeholder={"España"}
      {...props}
    />
  );
};

AutocompleteAddressHeadless.HiddenField = ({ name, as, ...props }) => (
  <Field name={name} as={as} hidden {...props} />
);
